__turbopack_context__.v({
  "Card": "Cards-module-sass-module__EqOH7a__Card",
  "CardCopy": "Cards-module-sass-module__EqOH7a__CardCopy",
  "CardImage": "Cards-module-sass-module__EqOH7a__CardImage",
  "Cards": "Cards-module-sass-module__EqOH7a__Cards",
  "CardsGrid": "Cards-module-sass-module__EqOH7a__CardsGrid",
  "Cont": "Cards-module-sass-module__EqOH7a__Cont",
  "Copy": "Cards-module-sass-module__EqOH7a__Copy",
  "Image": "Cards-module-sass-module__EqOH7a__Image",
  "Link": "Cards-module-sass-module__EqOH7a__Link",
  "Main": "Cards-module-sass-module__EqOH7a__Main",
  "NoBorderBottom": "Cards-module-sass-module__EqOH7a__NoBorderBottom",
});
